<template>
  <section v-if="notes.length || writeNotes" class="mt-3 mb-4 notes">
    <card title="Notes" icon="fas fa-sticky-note" class="mt-3" headerStyle="primary" bodyClasses="p-0">
      <div class="row px-3" :class="{'p-3 bg-light':background}">
        <div v-if="writeNotes" class="col py-3">
          <textarea id="note_content" :class="{'has-notes': notes.length}" class="form-control" :placeholder="textPlaceholder" v-model="formNote.content"></textarea>
          <jet-input-error :message="formNote.errors.content" class="mt-2" />

          <div class="mt-3 col-lg-4 px-0">
            <jet-button class="mb-2 w-100" icon="fas fa-plus" @click="addNote()">Save Note</jet-button>
            <div class="w-100">
              <slot></slot>
            </div>
          </div>
        </div>

        <div v-if="notes.length" class="col-lg-4 note-container bg-light py-3 pl-3 pl-lg-4">
          <p class="mb-1 text-secondary text-size-small"><i class="fas fa-clipboard"></i> {{notes.length}} notes</p>
          <div class="sticky-note mb-3 w-100" v-for="note in notes" :key="note.id">
            <div class="header bg-light border py-1 px-2">
              <strong>By: {{ note.user }} on {{ moment(note.date).format('M/D/YY h:mm A') }}</strong>
            </div>

            <div class="body p-2">
              <p class="m-0">{{ note.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </card>
  </section>
</template>

<script>
  import moment from 'moment'
  import JetInputError from '@/Jetstream/InputError'

  export default {
    components: {
      JetInputError
    },
    props: {
      notes: Array,
      formNote: Object,
      textPlaceholder: String,
      background: {
        type: Boolean,
        default: false
      },
      writeNotes: {
        type: Boolean,
        default: true
      }
    },
    created() {
      this.moment = moment
    },
    methods: {
      addNote() {
        this.$emit('addNote')
      }
    }
  }
</script>
